import buildClient from '@/api/client'
import getFilterPageItemsQuery from '@/api/filter-page-items'
import getFilterPageItemRecommendationsQuery from '@/api/filter-page-item-recommendations'
import { formatTags, formatVariants } from '../FilterPage/transformation-helpers'

function fetchFilterPageItemRecommendationsData(args) {
  const query = args.skus
    ? getFilterPageItemsQuery({ skus: args.skus })
    : getFilterPageItemRecommendationsQuery(args.excludeProductId)

  return buildClient()
    .query(query)
    .then(data => {
      const filterPageItems = data.filterPageItems || data.filterPageItemRecommendations

      let formattedItems = []
      filterPageItems.forEach(item => {
        formattedItems.push(formatVariants(formatTags(item)))
      })
      return formattedItems
    })
}

export default fetchFilterPageItemRecommendationsData
